/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, unknown } from '../schema';
import { Data12, data12Schema } from './data12';
import { Links, linksSchema } from './links';

export interface AC111Retrieveanaccount {
  data: Data12;
  links: Links;
  meta?: unknown;
}

export const aC111RetrieveanaccountSchema: Schema<AC111Retrieveanaccount> = object(
  {
    data: ['Data', lazy(() => data12Schema)],
    links: ['Links', lazy(() => linksSchema)],
    meta: ['Meta', unknown()],
  }
);
